<template>
  <div class="student-home">
    <section class="student-hero">
      <p>STUDENT CENTER</p>
      <h1>考试与答卷中心</h1>
      <span>请在规定时间内完成考试，提交后可在答卷中心查看批改结果。</span>
    </section>

    <section class="student-section">
      <div class="section-title">
        <div>
          <p>EXAMS</p>
          <h2>考试中心</h2>
        </div>
        <el-tag type="primary">{{ exams.length }} 场考试</el-tag>
      </div>
      <div v-if="exams.length <= 0" class="empty-card">当前暂无考试任务</div>
      <div class="exam-list" v-else>
        <article v-for="(exam, index) in exams" :key="index" class="exam-card">
          <div class="exam-icon">
            <i class="el-icon-edit-outline"></i>
          </div>
          <div class="exam-content">
            <h3>{{ exam.task_name }}</h3>
            <div class="exam-meta">
              <span>开始时间：{{ exam.begin_time }}</span>
              <span>考试类型：{{ exam.type_name }}</span>
              <span v-if="exam.task_type===0">结束时间：{{ exam.deadline }}</span>
            </div>
          </div>
          <el-button type="primary" v-if="exam.status===1" @click="goTest(exam.id)">开始考试</el-button>
          <el-button v-if="exam.status===0" disabled>{{ exam.show_status }}</el-button>
        </article>
      </div>
    </section>

    <section class="student-section">
      <div class="section-title">
        <div>
          <p>PAPERS</p>
          <h2>答卷中心</h2>
        </div>
        <el-tag type="success">{{ papers.length }} 份答卷</el-tag>
      </div>
      <div v-if="papers.length <= 0" class="empty-card">当前暂无答卷</div>
      <div class="paper-grid" v-else>
        <article v-for="paper in papers" :key="paper.id" class="paper-card">
          <div class="paper-card__head">
            <h3>{{ paper.task_name }}</h3>
            <i class="el-icon-document-checked"></i>
          </div>
          <div class="score-list">
            <span>系统评分 <strong>{{ paper.sys_score }}</strong></span>
            <span>教师评分 <strong>{{ paper.hand_score }}</strong></span>
            <span>最终成绩 <strong>{{ paper.final_score }}</strong></span>
          </div>
          <el-button type="primary" size="mini" @click="showPaper(paper.id)" v-if="paper.status===3">查看答卷</el-button>
          <el-button size="mini" @click="showPaper(paper.id)" v-else disabled>等待批改</el-button>
        </article>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: "StudentIndex",
  data() {
    return {
      exams: [],
      papers: [],
      banner_list: [],
    }
  },
  created() {
    this.getTaskList()
    this.getAnswerPapers()
    this.loadBanner()
  },
  methods: {
    loadBanner() {
      for (let i = 0; i < 4; i++) {
        let banner = this.$settings.BANNER_URL + `/media/banner/banner${i}.jpg`
        this.banner_list.push(banner)
      }
    },
    showPaper(id) {
      this.$router.push(`/StudentCheckPaper/?id=${id}`)
    },
    goTest(id) {
      this.$router.push(`/StudentExam/?id=${id}`)
    },
    getTaskList() {
      this.$http({
        url: this.$settings.BASE_URL + '/paper/student_index/exams/',
        method: 'get',
        params: {
          id: this.$cookies.get('userinfo').user_id
        }
      }).then(res => {
        if (res.data.code === 20000) {
          this.exams = res.data.result
        } else {
          this.$message({
            type: 'error',
            message: '获取信息出错'
          })
        }
      })
    },
    getAnswerPapers() {
      this.$http({
        url: this.$settings.BASE_URL + '/paper/student_index/answer_papers/',
        method: 'get',
        params: {
          id: this.$cookies.get('userinfo').user_id
        }
      }).then(res => {
        if (res.data.code === 20000) {
          this.papers = res.data.result
        } else {
          this.$message({
            type: 'error',
            message: '获取信息异常',
            duration: 3000,
          })
        }
      })
    },
  },
}
</script>

<style scoped>
.student-home {
  color: #173a58;
}

.student-hero {
  padding: 34px;
  border-radius: 24px;
  color: #fff;
  background:
      radial-gradient(circle at 88% 20%, rgba(255, 255, 255, 0.2), transparent 26%),
      linear-gradient(135deg, #103a63, #1878bd);
  box-shadow: 0 18px 40px rgba(24, 120, 189, 0.22);
}

.student-hero p {
  margin-bottom: 14px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.18em;
}

.student-hero h1 {
  margin-bottom: 12px;
  font-size: 34px;
}

.student-hero span {
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
}

.student-section {
  margin-top: 22px;
  padding: 24px;
  border-radius: 22px;
  background: #fff;
  border: 1px solid rgba(219, 232, 239, 0.92);
  box-shadow: 0 12px 32px rgba(28, 93, 141, 0.08);
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.section-title p {
  margin-bottom: 6px;
  color: #2aa5dc;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.18em;
}

.section-title h2 {
  color: #103a63;
  font-size: 24px;
}

.empty-card {
  padding: 34px;
  border-radius: 18px;
  color: #71889a;
  text-align: center;
  background: #f7fbfd;
  border: 1px dashed #cfe1eb;
}

.exam-list {
  display: grid;
  gap: 14px;
}

.exam-card {
  display: grid;
  grid-template-columns: 54px 1fr auto;
  gap: 16px;
  align-items: center;
  padding: 18px;
  border-radius: 18px;
  background: #f8fcfe;
  border: 1px solid #e3eef5;
}

.exam-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  border-radius: 16px;
  color: #fff;
  font-size: 24px;
  background: linear-gradient(135deg, #1878bd, #2aa5dc);
}

.exam-content h3 {
  margin-bottom: 10px;
  color: #173a58;
  font-size: 18px;
}

.exam-meta {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  color: #71889a;
  font-size: 13px;
}

.paper-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.paper-card {
  padding: 20px;
  border-radius: 20px;
  background: #f8fcfe;
  border: 1px solid #e3eef5;
}

.paper-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.paper-card__head h3 {
  min-height: 48px;
  color: #173a58;
  font-size: 17px;
  line-height: 1.45;
}

.paper-card__head i {
  color: #2aa5dc;
  font-size: 24px;
}

.score-list {
  display: grid;
  gap: 10px;
  margin: 18px 0;
}

.score-list span {
  display: flex;
  justify-content: space-between;
  color: #71889a;
  font-size: 14px;
}

.score-list strong {
  color: #103a63;
}

@media (max-width: 900px) {
  .exam-card {
    grid-template-columns: 1fr;
  }

  .paper-grid {
    grid-template-columns: 1fr;
  }
}
</style>
